/**
 * Polyfill para `global` en el navegador.
 *
 * Algunas dependencias de Node.js (p. ej. jsonapi-serializer → inflected)
 * acceden a `global` en tiempo de ejecución. En el navegador no existe,
 * lo que provoca `ReferenceError: global is not defined` en producción.
 * Este plugin se carga lo antes posible en el cliente y asigna
 * `window.global = window` antes de que se ejecute cualquier módulo
 * que dependa de él.
 */
export default defineNuxtPlugin(() => {
  if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
    window.global = window
  }
})
